import { useMemo } from 'react';
import type { Agent } from '../types';
import { type AgentRole, computeAgentRoles } from '../utils/agent-roles';

export type { AgentRole };

export function useAgentRoles(agents: Agent[]): Map<string, Set<AgentRole>> {
  return useMemo(() => computeAgentRoles(agents), [agents]);
}
